var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-shrink",attrs:{"id":"inbox"}},[_c('InboxNavigator'),_c('OrganizationTree')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }